<ng-container *ngrxLet="message$ as message">
    @if (message) {
        <div class="no-offers">
            @if (userService.isAuthenticated && areGroupedOffersEmpty) {
                @if (deviceService.isMobile) {
                    <div class="message-panel">
                        <div class="theme-info-i">
                            <div class="cms-container">
                                <div [innerHtml]="message?.noOfferMessage"></div>
                                <a (click)="getOffers()" class="link-external content-position col"
                                    >{{ message?.refresh }}<span class="theme-up"></span
                                ></a>
                            </div>
                        </div>
                    </div>
                }
            } @else {
                <div class="message-panel">
                    <div class="theme-info-i">
                        <div class="cms-container" [innerHtml]="message?.noOfferMessage"></div>
                    </div>
                </div>
            }
        </div>
    }
</ng-container>
